import Api from '../Api';

import { url } from './config';
import { Destination } from './types';

const api = new Api<Destination>(url);

export default api;
